import deMessages from '../locales/de_DE.json';

const DeLang = {
  messages: {
    ...deMessages,
  },
  locale: 'de-DE',
};
export default DeLang;
